@if (isMobile()) {
  @for (tournament of tournaments; track $index) {
    <fz-mobile-card-details
      class="mb--3 d--block"
      [tournament]="tournament"
      [includeToPlayNow]="true"
      (share)="onSharePress(tournament)"
    ></fz-mobile-card-details>
  }
} @else {
  <fz-shared-table-component
    [displayedColumns]="displayedColumns"
    [configuration]="configuration"
    [dataSource]="tournaments"
    [currentUser]="currentUser"
    [isLoggedIn]="isLoggedIn"
    [passesLoaded]="passesLoaded"
    [location]="location"
    [locationLoaded]="locationLoaded"
    queryParamsHandling="preserve"
    (elementClicked)="onTournamentPress($event.data)"
    (detailsButtonPressed)="onTournamentPress($event)"
    (shareButtonPressed)="onSharePress($event)"
    (pageChanged)="onPageChange($event)"
    (playButtonPressed)="onTournamentPress($event)"
  ></fz-shared-table-component>
}
